const PopUpHeader = ({ itemName }) => {
  return (
    <div className="bg-custom-orange text-white font-chinese text-3xl p-2 col-span-4">
      編輯{itemName}
    </div>
  );
};

export default PopUpHeader;
